import { expand } from 'uri-template-lite';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { BusinessLogDto, BusinessLogFilter } from '../schema/types';
import { PageRequestParams } from '../../common/queryClient';
import { apiClient } from '../../common/ApiClient';
import { BusinessLogUrl } from './BusinessLogUrl';
import { BusinessLogPageSchema } from '../schema/BusinessLogSchema';

const getBusinessLog = (params: BusinessLogFilter & PageRequestParams) =>
  apiClient
    .get<BusinessLogDto>(expand(BusinessLogUrl.SEARCH, params))
    .then((response) => BusinessLogPageSchema.parse(response.data));

export const useBusinessLogQuery = createApiQueryHook(
  ['businessLog'],
  getBusinessLog
);
